<div class="view-reading-room page">
  @if (!isLoading) {
    <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
    <div class="heading-wrapper">
      <h4>{{ readingRoom?.name }}</h4>
      <div class="actions">
        @if (readingRoom?.structuralUnit?.id && allowEditReadingRoom(readingRoom?.structuralUnit?.id || '')) {
          <button
            class="primary"
            [policyType]="CLAIM_SCOPE"
            [claimType]="CLAIM_TYPES['update']"
            (click)="navigateToEditPage()"
            appPermission>
            {{ 'pages.readingRoom.editReadingRoom' | translate }}
          </button>
        }
      </div>
    </div>
    <div class="main-info section">
      <div class="input-grid-first">
        <div>
          <p class="form-label lna">
            {{ 'pages.readingRoom.name' | translate }}
          </p>
          <p>{{ readingRoom?.name }}</p>
        </div>
        <div>
          <p class="form-label lna">
            {{ 'pages.readingRoom.nameEn' | translate }}
          </p>
          <p>{{ readingRoom?.nameEn }}</p>
        </div>
      </div>
      <div class="input-grid-second">
        <div>
          <p class="form-label lna">
            {{ 'pages.readingRoom.address' | translate }}
          </p>
          <p>{{ readingRoom?.address }}</p>
        </div>
        <div>
          <p class="form-label lna">
            {{ 'pages.readingRoom.coordinates' | translate }}
          </p>
          <p>{{ readingRoom?.latitude }}, {{ readingRoom?.longitude }}</p>
        </div>
      </div>
      <div class="input-grid-first">
        <div>
          <div class="label-wrapper">
            <p class="form-label lna">
              {{ 'pages.readingRoom.email' | translate }}
            </p>
            <app-tooltip text="email" />
          </div>
          <p>{{ readingRoom?.email }}</p>
        </div>
        <div>
          <div class="label-wrapper">
            <p class="form-label lna">
              {{ 'pages.readingRoom.phone' | translate }}
            </p>
            <app-tooltip text="contactPhone" />
          </div>
          <p>{{ readingRoom?.contactPhone }}</p>
        </div>
      </div>
      <div>
        <div class="label-wrapper">
          <p class="form-label lna">
            {{ 'pages.readingRoom.description' | translate }}
          </p>
          <app-tooltip text="description" />
        </div>
        <p>{{ readingRoom?.description }}</p>
      </div>
      <div class="mt-4">
        <div class="label-wrapper">
          <p class="form-label lna">
            {{ 'pages.readingRoom.descriptionEn' | translate }}
          </p>
          <app-tooltip text="descriptionEn" />
        </div>
        <p>{{ readingRoom?.descriptionEn }}</p>
      </div>
    </div>
    <div class="working-hours section">
      <div class="title-row px-0">
        <div class="header-wrapper">
          <h6>{{ 'pages.readingRoom.workingHours' | translate }}</h6>
          <app-tooltip [marginBottom]="false" text="workingHours" />
        </div>
      </div>
      @for (day of readingRoom?.scheduleEntries; track day) {
        <div class="day-input">
          <p class="form-label lna day-label">
            {{ 'pages.readingRoom.' + day?.day + 'Short' | translate }}
          </p>
          @if (day.isDayOff) {
            <p class="holiday">{{ 'pages.readingRoom.holiday' | translate }}</p>
          } @else {
            {{ formatTimeWithoutSeconds(day?.startTime) }}
            -
            {{ formatTimeWithoutSeconds(day?.endTime) }}
          }
        </div>
      }
    </div>
    <div class="notifications section">
      <div class="title-row">
        <div class="header-wrapper">
          <h6>{{ 'pages.readingRoom.notifications' | translate }}</h6>
          <app-tooltip [marginBottom]="false" text="notifications" />
        </div>
      </div>
      <div class="labels-wrapper">
        <div class="table-header_wrapper">
          <p>{{ 'pages.readingRoom.notificationText' | translate }}</p>
          <app-tooltip [marginBottom]="false" text="notificationText" [position]="'top-right'"></app-tooltip>
        </div>
        <div class="table-header_wrapper">
          <p>{{ 'pages.readingRoom.notificationTextEn' | translate }}</p>
          <app-tooltip [marginBottom]="false" text="readingRoomNotificationTextEn"></app-tooltip>
        </div>
        <div class="table-header_wrapper">
          <p>{{ 'pages.readingRoom.notificationFrom' | translate }}</p>
          <app-tooltip [marginBottom]="false" text="notificationFrom"></app-tooltip>
        </div>
        <div class="table-header_wrapper">
          <p>{{ 'pages.readingRoom.notificationTo' | translate }}</p>
          <app-tooltip [marginBottom]="false" text="notificationTo"></app-tooltip>
        </div>
      </div>
      @for (notification of readingRoom?.notificationEntries; track notification) {
        <div class="notification-input-wrapper">
          <div class="description-input-wrapper">
            <p>{{ notification.text }}</p>
          </div>
          <div class="description-input-wrapper">
            <p>{{ notification.textEn }}</p>
          </div>
          <div class="date-input-wrapper">
            @if (notification.startDate) {
              <p>{{ formatDate(notification.startDate) }}</p>
            }
          </div>
          <div class="date-input-wrapper">
            @if (notification.endDate) {
              <p>{{ formatDate(notification.endDate) }}</p>
            } @else {
              <p>{{ 'pages.readingRoom.noEndDate' | translate }}</p>
            }
          </div>
        </div>
      }
    </div>
    <div class="section">
      <div>
        <div class="label-wrapper">
        <p class="form-label lna">
          {{ 'pages.readingRoom.applicationEmail' | translate }}
        </p>
        <app-tooltip text="applicationEmail" />
      </div>
        <p>{{ readingRoom?.applicationEmail }}</p>
      </div>
      <div>
        <div class="label-wrapper">
          <p class="form-label lna">
            {{ 'pages.readingRoom.structuralUnit' | translate }}
          </p>
          <app-tooltip text="structuralUnitName" />
        </div>
        <p>{{ readingRoom?.structuralUnit?.name }}</p>
      </div>
      <div>
        <div class="label-wrapper">
          <p class="form-label lna">
            {{ 'pages.readingRoom.code' | translate }}
          </p>
          <app-tooltip text="readingRoomCode" />
        </div>
        <p>{{ readingRoom?.code }}</p>
      </div>
    </div>
  } @else {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="isLoading" />
    </div>
  }
</div>
